module.exports = __webpack_public_path__ + "static/media/FRA.d5a8e230.svg";